import { Mapper } from "../../../../base/utils/mapper";
import { VitalSignsResponseModel } from "../../../../domain/models/consult/vital-signs-response.model";
import { VitalSignsResponseEntity } from '../entities/vital-signs-response.entity';


export class VitalSignsImplementationRepositoryMapper extends Mapper<VitalSignsResponseEntity, VitalSignsResponseModel> {
    mapFrom(param: VitalSignsResponseEntity): VitalSignsResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: VitalSignsResponseModel): VitalSignsResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}